import {css} from '@emotion/react'
import {useMapContext} from '@/components/MindMap/index.mjs'

const cssList = css({
    padding: 8,
})

const cssListItem = css({
    color: '#410002',
    backgroundColor: '#fcebeb',
    padding: 8,
    marginBottom: 8,
    cursor: 'pointer',
})

const ListItem = ({message, path, ...props}) => {
    const map = useMapContext()

    const onClick = () => {
        const [node] = map.queryNodes({path})

        if (node) {
            map.execute(
                () => map.selectNodes([node])
            )
        }
    }

    return (
        <div
            css={cssListItem}
            title={path}
            onClick={onClick}
            {...props}
        >
            {message}
        </div>
    )
}

export default function ListErrors({errors, ...props}) {
    const listItems = errors.map(
        ({key, message, path}) => (
            <ListItem
                key={key}
                message={message}
                path={path}
            />
        )
    )

    return (
        <div
            css={cssList}
            {...props}
        >
            {listItems}
        </div>
    )
}
